import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import JsonLd from '@/components/feature/JsonLd';
import Hero from '@/pages/home/components/Hero';
import MarqueeBar from '@/pages/home/components/MarqueeBar';
import HotPicks from '@/pages/home/components/HotPicks';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import LatestFeed from '@/pages/home/components/LatestFeed';
import BrandIntro from '@/pages/home/components/BrandIntro';
import Testimonials from '@/pages/home/components/Testimonials';
import FaqSection from '@/pages/home/components/FaqSection';
import { articles } from '@/lib/content';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Home() {
  usePageMeta(
    '猎奇吃瓜 - 奇葩人物与迷惑行为大赏，沙雕新闻离谱故事天天更新',
    '猎奇吃瓜专注奇葩人物与迷惑行为，沙雕新闻、离谱故事、搞笑怪事天天更新。想看魔幻现实和魔幻操作，点开这里就能围观吃瓜。',
  );

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '猎奇吃瓜',
    description:
      '专注奇葩人物与迷惑行为，沙雕新闻、离谱故事、搞笑怪事天天更新，围观魔幻现实。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://ff41523.cn/?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '猎奇吃瓜',
    description: '中文内容娱乐栏目，专注整理奇葩人物、迷惑行为、沙雕新闻与离谱故事。',
    email: 'hello@lieqi-chigua.example.com',
  };

  const itemListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '最新爆料合集',
    itemListElement: articles.slice(0, 6).map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      url: `https://ff41523.cn/article/${item.id}`,
      name: item.title,
    })),
  };

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <JsonLd data={websiteSchema} />
      <JsonLd data={orgSchema} />
      <JsonLd data={itemListSchema} />
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <MarqueeBar />
        <HotPicks />
        <CategoryGrid />
        <LatestFeed />
        <BrandIntro />
        <Testimonials />
        <FaqSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}